<template>
  <div class="home">
    <div class="container wrapper">
      <div class="content">
        <div class="redheart"></div>
        <div class="whiteheart"></div>
        <div class="phone"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scope>
.home {
  width: 100%;
  height: calc(100% - 154.7px);
  .container {
    height: 100%;
    padding-bottom: 110px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      position: relative;
      height: 616px;
      max-height: calc(100%);
      width: 718px;
      .redheart {
        width: 492px;
        height: 432px;
        background: url(../assets/img/redheart.png) no-repeat 0 0;
        background-size: 492px 432px;
        position: absolute;
        top: 60px;
        left: 0;
      }
      .whiteheart {
        width: 269px;
        height: 235px;
        background: url(../assets/img/whiteheart.png) no-repeat 0 0;
        background-size: 269px 235px;
        position: absolute;
        top: 350px;
        left: 449px;
      }
      .phone {
        width: 580px;
        height: 616px;
        background: url(../assets/img/phone.png) no-repeat 0 0;
        background-size: 580px 616px;
        position: absolute;
        top: 0;
        left: 125px;
      }
    }
  }
}
</style>
